/**
 * Extracts the last two words from a string
 * @returns {string} A string representing the last two words of the given string
 */

export const getLastTwoWords = (value: string): string => {
  const words = value.trim().split(' ');
  const lastTwoWords = words.slice(-2).join(' ');

  return lastTwoWords;
};
